import React, { memo } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { PortalPharmaceuticalLayout, PortalLoggedLayout } from '../layouts';
import PharmaceuticalLoginPage from '../pages/portal-pharmaceutical/login';
import MyDataPage from '../pages/portal-pharmaceutical/signup/pages/MyDataPage';
import { RoutesEnum } from '../constants';
import DashboardPage from '../pages/portal-pharmaceutical/dashboard';
import DiscountsPage from '../pages/portal-pharmaceutical/discounts';
import ContentsPage from '../pages/portal-pharmaceutical/contents';
import RegulamentPage from '../pages/portal-pharmaceutical/regulament';
import MedicineLeafletsPage from '../pages/portal-pharmaceutical/medicine-leaflets/pages/MedicineLeafletsPage';
import { useAuth } from '../contexts/auth.context';
import termOfAcceptancePage from '../pages/portal-pharmaceutical/termOfAcceptance/index';
import { ScheduleIndicationPage } from '../pages/portal-pharmaceutical/schedule-indication/pages';
import PharmaceuticalSignupPage from '../pages/portal-pharmaceutical/signup/pages/PharmaceuticalSignUpPage';
import HTMLContentPage from '../pages/portal-pharmaceutical/common/components/HTMLContentPage';

function Routes(): JSX.Element {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div />;
  }

  return (
    <BrowserRouter>
      <Switch>
        {isAuthenticated ? (
          <Switch>
            <>
              <Route key="pharmaceutical_portal_routes" path={RoutesEnum.PHARMACEUTICAL_PANEL_PAGE}>
                <PortalLoggedLayout>
                  <Switch>
                    <Route path={RoutesEnum.PHARMACEUTICAL_MY_DATA} component={MyDataPage} exact />

                    <Route path={RoutesEnum.PHARMACEUTICAL_PANEL_DASHBOARD} component={DashboardPage} exact />
                    <Route path={RoutesEnum.SCHEDULE_INDICATION_ROUTE} component={ScheduleIndicationPage} exact />

                    <Route path={RoutesEnum.DISCOUNTS_ROUTE} component={DiscountsPage} exact />

                    <Route path={RoutesEnum.CONTENTS_ROUTE} component={ContentsPage} exact />
                    <Route path="/panel/contents/:slug" component={HTMLContentPage} />

                    <Route path={RoutesEnum.REGULATION_ROUTE} component={RegulamentPage} exact />
                    <Route path="/panel/regulation/:slug" component={HTMLContentPage} />

                    <Route path={RoutesEnum.MEDICINE_LEAFLETS_ROUTE} component={MedicineLeafletsPage} exact />
                  </Switch>
                </PortalLoggedLayout>
              </Route>
              {/* Catch-all route for invalid URLs */}
              <Route path="*">
                <Redirect to={RoutesEnum.PHARMACEUTICAL_PANEL_DASHBOARD} />
              </Route>
            </>
          </Switch>
        ) : (
          <>
            <Route key="pharmaceutical_portal_routes" path={RoutesEnum.PHARMACEUTICAL_LOGIN_PAGE}>
              <PortalPharmaceuticalLayout>
                <Switch>
                  <Route path={RoutesEnum.PHARMACEUTICAL_LOGIN_PAGE} component={PharmaceuticalLoginPage} exact />
                  <Route path={RoutesEnum.PHARMACEUTICAL_SIGNUP} component={PharmaceuticalSignupPage} exact />
                  <Route path={RoutesEnum.TERM_OF_ACCEPTANCE} component={termOfAcceptancePage} exact />

                  {/* Catch-all route for invalid URLs */}
                  <Route path="*">
                    <Redirect to={RoutesEnum.PHARMACEUTICAL_LOGIN_PAGE} />
                  </Route>
                </Switch>
              </PortalPharmaceuticalLayout>
            </Route>
          </>
        )}
      </Switch>
    </BrowserRouter>
  );
}

export default memo(Routes);
